// Styles
import Tabs from "components/Common/Tabs/Tabs";
import ConfigurationsContainer from "./Configurations.styles";

// Components
import ConfigurationsTab from "components/Screens/DailyRecs/Configurations/ConfigurationsTab/ConfigurationsTab";
import PowerBIDashboard from "components/Common/PowerBIDashboard/PowerBIDashboard";
import React from "react";

interface ConfigurationsProps {}

const Configurations = ({}: ConfigurationsProps) => {
    return (
        <ConfigurationsContainer>
            <p data-cy="navs-main-title" className={"sectionTitle"}>
                CONFIGURATIONS
            </p>
            <Tabs
                defaultTab="current_inputs"
                tabs={[
                    {
                        value: "current_inputs",
                        title: "CURRENT INPUTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ConfigurationsTab noSignOff />,
                    },
                    {
                        value: "proposed_inputs",
                        title: "PROPOSED INPUTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ConfigurationsTab />,
                    },
                    {
                        value: "report",
                        title: "REPORT",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: (
                            <div className="iframeContainer">
                                <PowerBIDashboard
                                    reportId="dae37a88-69ae-4214-a44b-b2a41712914c"
                                    workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128"
                                ></PowerBIDashboard>
                            </div>
                        ),
                    },
                ]}
            />
        </ConfigurationsContainer>
    );
};
export default Configurations;
